export const COMBO_BOX_LIST_OPTIONS = {
  limit: 9999,
  sort: { name: "ASC" },
};
